import { z } from 'zod';

import { idSchema } from './id';
import { paginationSchema } from './pagination';
import { hardSoftSkillShortSchema, languageSkillShortSchema, skillShortSchema } from './skill';

const baseUserJobSchema = z.object({
    id: idSchema,
    isNew: z.boolean(),
    publishedAt: z.string(),
    skills: skillShortSchema.array(),
    title: z.string(),
});

const skillShortSchemaWithUserLevel = z.union([
    hardSoftSkillShortSchema.extend({
        userLevel: z.number().optional().nullable(),
    }),
    languageSkillShortSchema.extend({
        userLevel: z.number().optional().nullable(),
    }),
]);

export type UserJobMatchingSkill = z.infer<typeof skillShortSchemaWithUserLevel>;

export const userJobRelevantSkillsSchema = z.object({
    matchingScore: z.number().optional(),
    matchingSkills: skillShortSchemaWithUserLevel.array(),
    missingSkills: skillShortSchema.array(),
});

export type UserJobRelevantSkills = z.infer<typeof userJobRelevantSkillsSchema>;

const userJobSchema = baseUserJobSchema.and(userJobRelevantSkillsSchema);

export type UserJob = z.infer<typeof userJobSchema>;

export const userJobPaginationSchema = z.object({
    data: userJobSchema.array(),
    pagination: paginationSchema,
});

export type UserJobPagination = z.infer<typeof userJobPaginationSchema>;
